import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cancelPlanAPI,
  changePasswordAPI,
  deleteAccountAPI,
  disableAccountAPI,
  freelancerProfileAPI,
  freelancerSignUpAPI,
  freelancerSubscriptionsAPI,
  openTalentSubscriptionsAPI,
  openTalentAvailabilityAPI,
  freelancerUpdateProfileDataAPI,
  freelancerUpdateProfileStepAPI,
  getPostJobsToFreelancers,
  openTalentJobsAPI,
  getSubscriptionDataAPI,
  offersAPI,
  profileStep1SubmitAPI,
  profileStep2SubmitAPI,
  profileStep3SubmitAPI,
  profileStep4SubmitAPI,
  purchaseSubscriptionAPI,
  raiseTicketAPI,
  getAllTicketsAPI,
  applyJobAPI,
  saveJobAPI,
  getAllSavedJobsAPI,
  appliedJobsAPI,
  reviewJobAPI,
  openTalentScheduleActionAPI,
  openTalentDashboardAPI,
} from "../../../../routes/apiurls";

// freelancer-sign-up
export const freelancerSignUp = createAsyncThunk(
  "freelancer-sign-up",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: freelancerSignUpAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-subscriptions
export const fetchSubscriptions = createAsyncThunk(
  "fetch-subscriptions",
  async () => {
    try {
      const response = await API_REQUEST({
        url: freelancerSubscriptionsAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-open-talent-subscriptions
export const fetchOpenTalentSubscriptions = createAsyncThunk(
  "fetch-open-talent-subscriptions",
  async () => {
    try {
      const response = await API_REQUEST({
        url: openTalentSubscriptionsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

// purchase-subscription
export const purchaseSubscription = createAsyncThunk(
  "purchase-subscription",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: purchaseSubscriptionAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// profile-step1-submit
export const profileStep1Submit = createAsyncThunk(
  "profile-step1-submit",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileStep1SubmitAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        currentPanel: "freelancer"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// profile-step2-submit
export const profileStep2Submit = createAsyncThunk(
  "profile-step2-submit",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileStep2SubmitAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        currentPanel: "freelancer"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// profile-step3-submit
export const profileStep3Submit = createAsyncThunk(
  "profile-step3-submit",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileStep3SubmitAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        isErrorToast: false,
        currentPanel: "freelancer"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// profile-step4-submit
export const profileStep4Submit = createAsyncThunk(
  "profile-step4-submit",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: profileStep4SubmitAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        currentPanel: "freelancer"
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

// fetch-freelancer-profile
export const fetchfreelancerProfile = createAsyncThunk(
  "fetch-freelancer-profile",
  async () => {
    try {
      const response = await API_REQUEST({
        url: freelancerProfileAPI,
        isErrorToast: false,
        isSuccessToast: false,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);


// fetch Jobs
export const fetchPostJobs = createAsyncThunk(
  "fetch-freelancer-post-job",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getPostJobsToFreelancers,
        isErrorToast: false,
        isSuccessToast: false,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchOpenTalentJobs = createAsyncThunk(
  "fetch-open-talent-jobs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: openTalentJobsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);


// fetch-offers
export const fetchOffers = createAsyncThunk("fetch-offers", async () => {
  try {
    const response = await API_REQUEST({
      url: offersAPI,
      isSuccessToast: false,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

export const changePassword = createAsyncThunk(
  "change-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: changePasswordAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const disableAccount = createAsyncThunk(
  "account-disable",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: disableAccountAPI,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const deleteAccount = createAsyncThunk(
  "account-delete",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: deleteAccountAPI,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const fetchSubscriptionData = createAsyncThunk(
  "fetch-subscription-data",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getSubscriptionDataAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const planCancel = createAsyncThunk(
  "plan-cancel",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: cancelPlanAPI,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const freelancerUpdateProfile = createAsyncThunk(
  "freelancer-profile-update",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: freelancerUpdateProfileDataAPI,
        data: payload,
        method: "PATCH",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const freelancerUpdateProfileStep = createAsyncThunk(
  "freelancer-profile-update-step",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: freelancerUpdateProfileStepAPI,
        data: payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateFreelancerAvailability = createAsyncThunk(
  "freelancer-availability-update",
  async (props) => {
    const { availabilityId, payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${openTalentAvailabilityAPI}/${availabilityId}`,
        data: payload,
        method: "PATCH",
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const fetchFreelancerAvailability = createAsyncThunk(
  "freelancer-availability-fetch",
  async () => {
    try {
      const response = await API_REQUEST({
        url: openTalentAvailabilityAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const deleteFreelancerAvailability = createAsyncThunk(
  "freelancer-availability-delete",
  async (props) => {
    const { availabilityId, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${openTalentAvailabilityAPI}/${availabilityId}`,
        method: "DELETE",
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const createFreelancerAvailability = createAsyncThunk(
  "freelancer-availability-create",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: openTalentAvailabilityAPI,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const raiseSupportTicket = createAsyncThunk(
  "raise-support-ticket",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: raiseTicketAPI,
        method: "POST",
        data: payload,
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const fetchAllTickets = createAsyncThunk(
  "fetch-all-tickets",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getAllTicketsAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const applyOpenTalentJob = createAsyncThunk(
  "apply-open-talent-job",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: applyJobAPI,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const saveOpenTalentJob = createAsyncThunk(
  "save-open-talent-job",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: saveJobAPI,
        method: "POST",
        data: payload,
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const fetchSavedOpenTalentJobs = createAsyncThunk(
  "fetch-saved-open-talent-jobs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getAllSavedJobsAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchAppliedOpenTalentJobs = createAsyncThunk(
  "fetch-applied-open-talent-jobs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: `${appliedJobsAPI}`,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const reviewOpenTalentJob = createAsyncThunk(
  "review-open-talent-job",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: reviewJobAPI,
        method: "POST",
        data: payload,
        isSuccessToast: false,
        isErrorToast: false,
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);

export const fetchOpenTalentDashboard = createAsyncThunk(
  "fetch-open-talent-dashboard",
  async () => {
    try {
      const response = await API_REQUEST({
        url: openTalentDashboardAPI,
        method: "GET",
        isSuccessToast: false,
        currentPanel: "freelancer",
      });
      return response;
    } catch (error) { }
  }
);

export const scheduleOpenTalentInterviewAction = createAsyncThunk(
  "schedule-open-talent-interview-action",
  async (props) => {
    const { payload, params, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${openTalentScheduleActionAPI}${params}/schedule-action`,
        method: "PUT",
        data: payload,
        currentPanel: "freelancer",
      });
      if (callback) callback(response);
      return response;
    } catch (error) {
      if (callback) callback(null, error);
    }
  }
);
